export default function CountWidget({ count, title, icon }) {
    return (
        <div className="count-widget">
            <img src={icon} alt={title} />
            <div className="count-widget-text">
                <h2>{count}</h2>
                <h3>{title}</h3>
            </div>
        </div>
    );
}